<script lang="ts">
    import { afterNavigate } from '$app/navigation';
    import { pageview } from '$src/lib/services/gtm';

    afterNavigate(({ from }) => {
        if (!from) return;
        pageview({
            pagePreviousUrl: from.url.href
        });
    });
</script>
